import styled from "styled-components";

export const HeaderWrap = styled.div`
  z-index: 9999;
`;
